import {
  Chip,
  CurrentBreadCrumb,
  IconButton,
  useRuntimeEnv,
  useTranslationRoute,
  useUrlParamsValue,
} from "@bsm/component";
import React from "react";
import { AvatarMenu } from "../menu/AvatarMenu";
import { LanguageMenu } from "../menu/LangMenu";
import "./css/navbar.css";
import { atom } from "recoil";
import { NotificationMenu } from "./NotificationMenu";
import { ChevronsLeft, ChevronsRight } from "lucide-react";

export const AdminNavBar = ({ onToggleSidebar, openedToggleSidebar }: NavBarProps) => {
  return (
    <header
      className={`sticky top-0 flex z-50 backdrop-blur-lg bg-white/50 justify-between items-center gap-4 py-3 px-4 shadow-md`}
    >
      <div
        className={`
          absolute left-[-22px] top-[19px]
          z-[999999]
          flex items-center justify-center
          size-[40px]
          rounded-full
          bg-white
          shadow-lg
          cursor-pointer
          transition-all
        `}
        onClick={onToggleSidebar}
      >
        {openedToggleSidebar ?
          <ChevronsLeft
            size={20}
            strokeWidth={2.4}
            className="text-[#1E1B4B]"
          /> :
          <ChevronsRight
            size={20}
            strokeWidth={2.4}
            className="text-[#1E1B4B]"
          />
        }
      </div>
      <div className="ml-5 hidden lg:block">
        <CurrentBreadCrumb
          activeFn={(item) => item.link === window.location.pathname}
        />
      </div>

      <div className="ml-auto">
        <ul className="flex items-center w-[max-content] !gap-[25px] sm:gap-4">


          <li>
            <NotificationMenu />
          </li>

          <li>
            <LanguageMenu />
          </li>

          {/* <li className="hidden md:block">
                        <OrganisationMenu />
                    </li> */}
          <li className="flex-shrink-0">
            <AvatarMenu />
          </li>
        </ul>
      </div>
    </header>
  );
};

export type NavBarProps = {
  onToggleSidebar?: () => void;
  openedToggleSidebar?: boolean
};

export const calendarOpenState = atom({
  key: "calendarOpenState",
  default: false,
});
